// import ServiceBus from "servicestack/service-bus";
export const nav = 1;
import config from "emun.catalogs/catalog.config";

export const getStates = (menu, mode = "catalog", other) => {
  const base = menu ? `${menu}.${mode}` : mode;
  return {
    [base]: {
      nav,
      menu, // <ui-view/>
      breadcrumbs: false,
      pageHeader: false,
      icon: "columns",
      title: "Catalogs",
      url: "/" + mode + "?landingPageTagKind",
      params: {},
      rerouteTo: `${base}.list`,
      authorize: (s) => s.hasPermission("ViewCatalogs"),
      resolve: {
        orderId: ($stateParams) => $stateParams.orderId,
      },
      templateProvider: ($stateParams) => `<catalog-container 
        order-id="${$stateParams.orderId}"  
        />`,
      ...other,
    },
    [`${base}.list`]: {
      menu: base,
      nav: false,
      breadcrumbs: false,
      pageHeader: false,
      icon: "usd",
      title: "List",
      resolve: {},
      templateProvider: ($stateParams) => `<catalog-list  />`,
    },
    [`${base}.detail`]: {
      menu: base,
      nav: false,
      url: "/{catalogId:[^/]+}",
      title: "Detail",
      breadcrumbs: false,
      pageHeader: false,
      params: { initialState: config.catalogInitialState },
      authorize: (s) => s.hasPermission("ManageCatalogs"),
      templateProvider: ($stateParams) =>
        `<catalog-details catalog-id="'${$stateParams.catalogId}'"  />`,
    },
    [`${base}.detail.section`]: {
      menu: base,
      nav: false,
      url: "/section/{sectionId:[^/]+}",
      title: "Detail",
      breadcrumbs: false,
      pageHeader: false,
      params: {},
      resolve: {
        sectionId: ($window, $stateParams) => $stateParams.sectionId,
        // catalogId: ($window, $stateParams) => $stateParams.catalogId
      },
      templateProvider: ($stateParams) => `<catalog-details-sections  />`,
    },
  };
};

export default getStates();
